<template>
	<div
		class="skip-ad"
		:class="{ 'is-mobile': isMobileWebApp }"
	>
		<div class="skip-ad__remaining-time">
			<span>{{ labels.ad }}</span>
			<span>&centerdot;</span>
			<span>{{ adRemainingTime }}</span>
		</div>
		<div class="skip-ad__skip-wrapper">
			<button
				v-if="adSkipAllowed"
				class="skip-ad__skip-button"
				:class="{ 'is-skippable': canSkipAd }"
				data-testid="skip-ad-skip-button"
				@click.stop.prevent="handleSkipAd"
			>
				<span class="skip-ad__skip-label">
					{{ labels.ad_skip }}
				</span>
				<Icon
					v-if="canSkipAd"
					icon-name="pointing-right"
					size="sm"
				/>
				<span v-else>
					{{ labels.ad_skip_in_seconds.split(":seconds").join(adSkipTime) }}
				</span>
			</button>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
	name:  'SkipAd',
	props: {
		adRemainingTime: {
			type: Number,
		},
		adSkipAllowed: {
			type: Boolean,
		},
		canSkipAd: {
			type: Boolean,
		},
		adSkipTime: {
			type: Number,
		},
	},
	computed: {
		...mapGetters({
			isMobileWebApp: 'app/isMobileWebApp',
		}),
		labels() {
			return Object.entries({
				ad:                 ['monetization.ad', 'Ad'],
				ad_skip:            ['monetization.ad_skip', 'Skip LegacyAd'],
				ad_skip_in_seconds: ['monetization.ad_skip_in_seconds', 'in :seconds seconds'],
			}).reduce((acc, [k, v]) => {
				const [path, defaultValue] = v;
				acc[k] = this.$I18n ? this.$I18n.trans(path) : defaultValue;
				return acc;
			}, {});
		},
	},
	methods: {
		handleSkipAd(e) {
			if (!this.canSkipAd) {
				e.preventDefault();
				return;
			}
			this.$emit('skip-ad');
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';
@import '@videotools/sass/_fonts';

.skip-ad {
	&.is-mobile {
		position: initial;
		height: auto;
		bottom: 0;
		@include text-sm-1;
	}
}

.skip-ad__skip-label {
	margin-right: 12px;
}

.skip-ad__remaining-time {
	position: absolute;
	left: 0;
	top: 0;
	padding: 4px 8px;
	font-size: 12px;
	background-color: rgba(var(--color-rgb-black), 0.3);
	color: var(--color-white);
	z-index: 4;

	span + span {
		margin-left: 6px;
	}

	.skip-ad.is-mobile & {
		top: auto;
		bottom: 2px; // offset from the timeline
	}
}

.skip-ad__skip-wrapper {
	position: absolute;
	right: 0;
	bottom: 20%;
	z-index: 4;
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	place-content: flex-end;
}

.skip-ad__skip-button {
	flex: 0 0 auto;
	display: flex;
	flex-direction: column;
	text-align: center;
	padding: 8px 16px;
	background: rgba(var(--color-rgb-black), 0.6);
	border-radius: 2px 0 0 2px;
	font-size: 12px;
	align-items: center;
	line-height: 16px;
	pointer-events: initial;
	z-index: 3;

	> span {
		display: block;
	}

	&.is-skippable {
		height: 40px;
		flex-direction: row;
		font-size: 12px;
		color: var(--color-text-on-hype-yellow);
		border-color: var(--color-hype-yellow);
		background-color: var(--color-hype-yellow);
		transition: background 0.2s;

		.skip-ad.is-mobile & {
			height: 36px;
		}

		&:hover {
			background-color: var(--color-hype-yellow--active);
			border-color: var(--color-hype-yellow--active);
		}
	}

	.skip-ad.is-mobile & {
		padding: 6px 12px;
	}
}

</style>
